/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { FiLogOut } from "react-icons/fi";
import { removeToken } from "../utils/token";
import { useNavigate } from "react-router-dom";
const NavbarAdmin = () => {
  const navigate = useNavigate();
  const logout = () => {
    removeToken();
    navigate("/");
  };
  return (
    <nav className="navbar navbar-expand-lg navbar-light bg-light fixed-top shadow">
      <div className="container">
        <a className="navbar-brand" href="/admin">
          <span className="nj">N.J</span> <span className="achat">Admin</span>
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className="collapse navbar-collapse justify-content-end"
          id="navbarNav"
        >
          <ul className="navbar-nav" onClick={logout}>
            <li className="nav-item">
              <a className="nav-link custom-link">
                Déconnexion <FiLogOut />
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavbarAdmin;
